export const cy_GB = {
    LEFT: 'Chwith: Symud y diwrnod blaenorol.',
    RIGHT: 'Dde: Symud i\'r diwrnod nesaf.',
    DOWN: 'I lawr: Symud at y rhes nesaf.',
    UP: 'Hyd: yn Symud at y rhes blaenorol.',
    PGUP: 'PgUp: Symud y mis blaenorol.',
    PGDOWN: 'PgDown: Symud y mis nesaf.',
    HOME: 'Cartref: Symud i\'r flwyddyn flaenorol.',
    END: 'Diwedd: Symud ymlaen i\'r flwyddyn nesaf.',
    ESC: 'Esc/Heddiw/Agos: cau yn y calendr.',
    TITLE: 'Bysellfwrdd Cyfarwyddiadau'
};
